import { Modal, Box } from '@mui/material';
import { ReactComponent as Close } from '../assets/icon/Close.svg';
import { useState } from 'react';
import PlainButton, { UnileverButton } from './ButtonComponents';
import { CopyIcon } from 'lucide-react';
import {
  CreatePromptTemplate,
  DeletePromptTemplate,
  EditPromptTemplate,
  GetAllPromptsTemplate,
  GetPromptTemplate,
  SavePromptTemplate,
  //   EndPoints
  CreatePromptEndPoint,
  DeletePromptEndPoint_Master,
  DeletePromptEndPoint_Version,
  EditPromptEndPointNewVersion,
  EditPromptEndPointSameVersion,
  GetAllPromptsEndPoint,
  GetPromptEndPoint,
  SavePromptEndPoint,
  headers
} from '../data/CodyCopyData/CreatePrompt';
import { pythonFileTemplate } from '../data/CodyCopyData/pytonFile';
import { useAzureData } from '../context/AzureContext';
import { usePromptLibraryContext } from '../context/PromptLibraryContext';
import { appConfig } from '../config/appConfig';
const hoverStyles = `
  .CodeIcon,
  .linkIcon {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease;
   
  }

  .CodeContainer:hover .CodeIcon,
  .linkContainer:hover .linkIcon {
    opacity: 1;
    visibility: visible;
    
 
  }
    .CodeContainer:hover,
.linkContainer:hover{
  cursor:pointer;
  background-color:rgba(131, 143, 180, .1);
    transition: opacity 0.10s ease;
   padding:2px;
   font-weight:500
  }

 
`;

export default function CodeViewPopUp({ open = false, handleClose = () => {} }) {
  const { apiToken = '' } = useAzureData();
  const BASE_URL = appConfig.api.baseUrl;
  const { promptDetails, codeViewPromptId } = usePromptLibraryContext();
  const commonComment = `
  #Fill Placeholder (*Required)
    #<VERSION_ID>= Version Id of the Selected Version`;

  const displayData = [
    {
      buttonName: 'Create',
      code: CreatePromptTemplate,
      link: CreatePromptEndPoint,
      specificComment: ''
    },
    {
      buttonName: 'Delete (Master)',
      code: DeletePromptTemplate,
      link: DeletePromptEndPoint_Master,
      specificComment: ``
    },
    {
      buttonName: 'Delete (Version)',
      code: DeletePromptTemplate,
      link: DeletePromptEndPoint_Version,
      specificComment: ``
    },
    {
      buttonName: 'Edit (to same Version)',
      code: EditPromptTemplate,
      link: EditPromptEndPointNewVersion,
      specificComment: `    #<VERSION_NUMBER> = Version Number to be Edited`
    },
    {
      buttonName: 'Edit (as New Version)',
      code: EditPromptTemplate,
      link: EditPromptEndPointSameVersion,
      specificComment: `    #<VERSION_NUMBER> = Version Number to be Edited`
    },
    {
      buttonName: 'Get All Prompts',
      code: GetAllPromptsTemplate,
      link: GetAllPromptsEndPoint,
      specificComment: ''
    },
    {
      buttonName: 'Get Specific Prompt',
      code: GetPromptTemplate,
      link: GetPromptEndPoint,
      specificComment: ''
    }
    // { buttonName: 'Save Prompt', code: SavePromptTemplate, link: SavePromptEndPoint }
  ];

  const [selectedButtonIndex, setSelectedButtonIndex] = useState(0);

  const buttonDisplay = (item: string, index: number) => {
    return selectedButtonIndex === index ? (
      <UnileverButton buttonAction={() => setSelectedButtonIndex(index)}>{item}</UnileverButton>
    ) : (
      <PlainButton buttonAction={() => setSelectedButtonIndex(index)}>{item}</PlainButton>
    );
  };

  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log('Copied to clipboard');
    } catch (err) {
      console.error('Failed to copy', err);
    }
  };

  const selectedButton = displayData[selectedButtonIndex];
  let codeData = selectedButton?.code;
  let codeUrl = selectedButton?.link?.url;

  if (codeViewPromptId) {
    if (promptDetails?.loading) {
      return;
    }
    // temperoray selecting  first version for showing the code
    const temp_promptData = promptDetails?.data?.promptsData?.[0];
    const temp_prompt = temp_promptData?.prompt;
    const temp_promptData_meta = promptDetails?.data?.meta;
    const PromptId = promptDetails?.data?.prompt_id;
    const promptVersionNumber = temp_prompt?.promptVersion;
    const {
      promptVersion = '',
      llmTestedWith = '',
      promptDescription = '',
      systemPrompt = '',
      is_prompt_type_private = false,
      is_interaction_type_single = false,
      businessGroup = '',
      promptName = '',
      prompt = ''
    } = temp_prompt;

    const { roles = [], variables = [], version_id = '' } = temp_promptData;
    const { totalVersions = '' } = temp_promptData_meta;
    function capitalizeFirst(str: string) {
      if (!str) return str;
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
    const replacements: Record<string, string> = {
      '<Business_Group>': businessGroup,
      '<Prompt_Name>': promptName,
      '<Prompt_Version>': promptVersion,
      '<LLM_Tested_With>': llmTestedWith,
      '<Prompt_Description>': JSON.stringify(promptDescription),
      '<System_Prompt>': JSON.stringify(systemPrompt),
      '<Prompt_Type>': capitalizeFirst(String(is_prompt_type_private)),
      '<Interaction_Type>': capitalizeFirst(String(is_interaction_type_single)),
      '<Prompt>': JSON.stringify(prompt, null, 2),
      '<Role>': JSON.stringify(roles, null, 2),
      '<Variable_Data>': JSON.stringify(variables, null, 2),
      '<Total_Versions>': String(totalVersions)
    };

    codeData = Object.entries(replacements).reduce(
      (code, [key, value]) => code?.replace(key, value ?? ''),
      selectedButton?.code
    );

    codeUrl = selectedButton?.link?.url
      ?.replace('<PROMPT_ID>', PromptId)
      // ?.replace('<VERSION_ID>', String(version_id))
      ?.replace('<VERSION_NUMBER>', promptVersionNumber);
  }

  const indentMultiline = (value: string, spaces = 4) => {
    const pad = ' '.repeat(spaces);
    return value
      .split('\n')
      .map((line, index) => (index === 0 ? line : pad + line))
      .join('\n');
  };

  const copyCodeFunction = (isCopy = false) => {
    const withOutPayload = `url, headers=headers`;
    const withPayload = `url, json=payload,headers=headers`;
    const Dump_response_json = 'json.dumps(response.json())';
    const response_json = 'response.json()';

    const templateReplacements: Record<string, string> = {
      '<payload>': indentMultiline(codeData, 6),
      '<url>': `${BASE_URL}${codeUrl}`,
      '<header>': indentMultiline(headers, 6),
      '<RequestType>': selectedButton?.link?.type?.toLowerCase(),
      '<requestData>':
        ['post', 'put']?.indexOf(selectedButton?.link?.type?.toLowerCase()) > -1
          ? withPayload
          : withOutPayload,
      '<response_json>':
        selectedButton?.link?.type?.toLowerCase() === 'put' ? Dump_response_json : response_json,
      '<Common_Comment>': commonComment,
      '<Specific_Comment>': selectedButton?.specificComment
    };

    return Object.entries(templateReplacements).reduce(
      (template, [key, value]) => template?.replace(key, value ?? ''),
      pythonFileTemplate
    );
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="alignDataCenter">
      <Box
        style={{
          backgroundColor: 'rgba(255, 255, 255, 1)',
          border: 'none',
          width: '1000px',
          height: '1350px',
          margin: 'auto',
          maxWidth: '80vw',
          maxHeight: '80vh',
          borderRadius: '8px',
          padding: 20,
          overflow: 'auto'
        }}>
        <style>{hoverStyles}</style>
        <Box className="d-flex justify-content-between align-items-start">
          <div>
            <div className="h6 w600 un_standard_color" style={{ margin: '10px 0' }}>
              Prompt Library Python Codes
            </div>
            <div>{displayData?.map((item, index) => buttonDisplay(item?.buttonName, index))}</div>
          </div>
          <Close style={{ cursor: 'pointer' }} onClick={handleClose} />
        </Box>

        <div
          className="linkContainer"
          style={{
            background: 'var(--card_border)',
            margin: '10px 0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: '40px',
            borderRadius: 4
          }}
          onClick={() => {
            copyToClipboard(codeUrl || '');
          }}>
          <div>
            <span
              style={{
                padding: '4px 10px',
                borderRadius: '6px',
                fontSize: '12px',
                fontWeight: 600,
                marginRight: '8px'
              }}>
              {selectedButton?.link?.type}
            </span>{' '}
            <code
              style={{
                padding: '6px 10px',
                borderRadius: '6px',
                fontSize: '13px',
                wordBreak: 'break-all',
                color: '#000'
              }}>
              {codeUrl}
            </code>
          </div>
          <CopyIcon className="linkIcon" />
        </div>

        <div
          className="d-flex justify-content-between CodeContainer"
          onClick={() => {
            copyToClipboard(copyCodeFunction(true)?.replace('<YOUR_TOKEN_HERE>', apiToken) || '');
          }}>
          <pre style={{ whiteSpace: 'pre-wrap' }}>
            <code>
              {/* {selectedButton?.code} */}
              {copyCodeFunction()}
            </code>
          </pre>
          <CopyIcon className="CodeIcon" />
        </div>
      </Box>
    </Modal>
  );
}
